<div class="audioBtnWrapper">
  <div class="d-inline">
    @if (this.getState() === 'idle') {
      <button
        class="btn  playT2S"
        (click)="this.playAudio()"
        [disabled]="this.isDisabled()"
        >
        <i class="ri-play-circle-line ri-lg"></i>
      </button>
    }
    @if (this.getState() === 'load') {
      <button
        class='btn loadT2S'
        >
        <i class='ri-loader-4-line ri-lg'></i>
      </button>
    }
    @if (this.getState() === 'play') {
      <button
        class='btn  playT2S'
        (click)='this.stopAudio()'
        [disabled]="this.isDisabled()"
        >
        <i class='ri-stop-circle-line ri-lg'></i>
      </button>
    }
  </div>
</div>